export default function PHP_htmlspecialchars_decode() {
  return (
    <div>
      <h1>PHP_htmlspecialchars_decode</h1>
    </div>
  );
}
